import { format, parseUrlDate } from '../utils/date/dateUtils';
import { urlUtils } from '../utils/url';

const combinationModel = {
  get sessionId() {
    return urlUtils.getSessionIdFromUrl();
  },
  get rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
  get departureAirportWvId() {
    return urlUtils.getDepartureWvIdFromUrl();
  },
  get resortId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get areaId() {
    const areaId = urlUtils.getAreaIdFromUrl();
    return areaId === '-1' ? '' : areaId;
  },
  get departureDate() {
    const departureDate = urlUtils.getDepartureDateFromUrl();

    if (!departureDate) {
      return null;
    }

    const parsedDepartureDate = parseUrlDate(urlUtils.getDepartureDateFromUrl());
    return format(parsedDepartureDate, '-');
  },
  get returnDate() {
    const returnDate = urlUtils.getReturnDateFromUrl();

    if (!returnDate) {
      return null;
    }

    const parsedReturnDate = parseUrlDate(urlUtils.getReturnDateFromUrl());
    return format(parsedReturnDate, '-');
  },
  get duration() {
    return urlUtils.getDurationFromUrl();
  },
  get accomodationKeys() {
    return urlUtils.getAccommodationKeysFromUrl();
  },
  get transportKey() {
    return urlUtils.getTransportKeyFromUrl();
  },
  get transportId() {
    return urlUtils.getTransportIdFromUrl();
  },
  get sequence() {
    return urlUtils.getSequenceFromUrl();
  },
  get tripRuleId() {
    return urlUtils.getTripRuleIdFromUrl();
  },
  get tdmRuleId() {
    return urlUtils.getTdmRuleIdFromUrl();
  },
  get selectedCabin() {
    return urlUtils.getSelectedCabinFromUrl();
  },
  get CruiseCode() {
    return urlUtils.getCruiseCodeFromUrl();
  },
  get CruiseId() {
    return urlUtils.getCruiseIdFromUrl();
  },
  get tags() {
    return urlUtils.getTagsFromUrl();
  },
  get classifications() {
    return urlUtils.getClassificationsFromUrl();
  },
  get tdmType() {
    return urlUtils.getTdmTypeFromUrl();
  },
  get CabinClass() {
    return urlUtils.getCabinClassFromUrl();
  },
  get DirectFlight() {
    return urlUtils.getFastestFlightFromUrl();
  },
  get IncludeBaggage() {
    return urlUtils.getIncludeBaggageFromUrl();
  },
};

export default combinationModel;
